import styled from 'styled-components';
import RcTextArea from 'rc-textarea';
import type { PaletteType, DesignType, SizeType } from './types';

export const SIZES = {
  // XXSMALL: 20,
  XSMALL: 30,
  SMALL: 40,
  MEDIUM: 50,
  // LARGE: 60,
  // XLARGE: 70,
  // XXLARGE: 80,
};

export const TextAreaStyled = styled(RcTextArea)<{
  palette?: PaletteType;
  design?: DesignType;
  // collisiton with <input size /> attribute
  xsize?: SizeType;
}>`
  background: ${({ palette }) => {
    switch (palette) {
      case 'primary': {
        return '#ea475c';
      }
      case 'secondary': {
        return 'rgba(255, 255, 255, 0.5)';
      }
      case 'tertiary': {
        return 'rgba(255, 255, 255, 1)';
      }
      default: {
        return 'rgba(136, 136, 136, 0.1)';
      }
    }
  }};

  color: ${({ palette }) => {
    switch (palette) {
      case 'primary': {
        return '#fff';
      }
      default: {
        return '#292929';
      }
    }
  }};

  font-size: ${({ xsize }) => {
    switch (xsize) {
      case 'xsmall': {
        return '14px';
      }
      case 'small': {
        return '16px';
      }
      default: {
        return '20px';
      }
    }
  }};

  font-family: 'Lato', sans-serif;
  font-weight: normal;
  border-radius: 4px;
  border: none;
  margin: 0;
  line-height: 1.2;

  &[disabled] {
    opacity: 0.6;
  }
`;
